export { default as App } from './app/app';
export { default as Header } from './header/header';
export { default as Footer } from './footer/footer';
export { default as Page } from './page/page';